import type { MouseEvent } from "react";

import { ProgressBarWithValueCell } from "@similarweb/pro-logic-components";
import type { ColumnsType } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { getIndexCellPropsForTableV2 } from "app/components/React/Table/cells/IndexCell";
import { WebsiteTooltip } from "app/components/React/Tooltip/WebsiteTooltip/WebsiteTooltip";
import { CoreWebsiteCell } from "pro-features/components/core cells/src/CoreWebsiteCell/CoreWebsiteCell";

import { formatPercentValue } from "../../utils/utils";

export interface ITopDomainRow {
    domain: string;
    favicon: string;
    share: number;
}

const SHARE_VALUE_MIN_WIDTH = "48px";
// Widen the row-number column so two-digit ranks (10+) aren't clipped.
const INDEX_COLUMN_MIN_WIDTH = 60;

export const getColumns = (
    currentPage: number,
    pageSize: number,
    domainColumnTitle: string,
    shareColumnTitle: string,
    onDomainClick: (domain: string) => void,
): ColumnsType<ITopDomainRow> => [
    {
        ...getIndexCellPropsForTableV2<ITopDomainRow>(currentPage, pageSize, undefined, INDEX_COLUMN_MIN_WIDTH),
    },
    {
        dataIndex: "domain",
        title: domainColumnTitle,
        render: (domain: string, row: ITopDomainRow) => (
            <CoreWebsiteCell
                domain={domain}
                icon={row.favicon}
                hideTrackButton
                textAndIconMargin="8px"
                internalLinkDataAutomationAttribute="industry-top-domains-domain-link"
                trackInternalLink={(event: MouseEvent<HTMLAnchorElement>) => {
                    event.preventDefault();
                    onDomainClick(domain);
                }}
                TooltipComponent={({ children }) => (
                    <WebsiteTooltip
                        domain={domain}
                        placement="bottom-left"
                        debounce={500}
                        hideTrackButton
                    >
                        {children}
                    </WebsiteTooltip>
                )}
            />
        ),
    },
    {
        dataIndex: "share",
        title: shareColumnTitle,
        align: "left",
        render: (share: number) => (
            <ProgressBarWithValueCell
                share={share}
                value={formatPercentValue(share)}
                color={colorsPalettes.blue[400]}
                valueMinWidth={SHARE_VALUE_MIN_WIDTH}
            />
        ),
    },
];
